import { render, staticRenderFns } from "./VaTreeRoot.demo.vue?vue&type=template&id=66951f25&"
import script from "./VaTreeRoot.demo.vue?vue&type=script&lang=js&"
export * from "./VaTreeRoot.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports